import { render, staticRenderFns } from "./PrometIPoslednjaPoseta.vue?vue&type=template&id=bf588436&"
import script from "./PrometIPoslednjaPoseta.vue?vue&type=script&lang=ts&"
export * from "./PrometIPoslednjaPoseta.vue?vue&type=script&lang=ts&"
import style0 from "./PrometIPoslednjaPoseta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports